import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import core from './stores/core'

Vue.use(Vuex)

export default new Vuex.Store({
  debug: true,
  modules: {
    core
  },
  plugins: [store => {
    store.subscribeAction(({ type }, state) => {
      const module = type.split('/')[0]

      // Clear previous errors when action is dispatching.
      if (_.has(state[module], 'error')) {
        store.commit(`${module}/error`, {
          data: {},
          message: ''
        })
      }
    })
  }],
  strict: true
})
